module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/twitch-ce742009051584dd51ccadefec8f4355.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/twitch.svg
// module id = u0+v
// module chunks = 24